<template>
  <div class="mainAll">
    <div class="header_h">
      数据字典管理
    </div>
    <div class="left">
      <div class="button-1">
        <el-checkbox v-model="checked" @change="allCheck">{{ checkTitle }}</el-checkbox>
        <el-button type="primary" plain size="small" icon="el-icon-plus" title="添加分类" @click="addDicTree">
        </el-button>
        <el-button type="primary" plain size="small" :disabled="!isDisabled" class="el-icon-edit" title="修改分类" @click="editDicTree">
        </el-button>
      </div>
      <div class="tree_font">
        <el-input v-model="keyWord" placeholder="请输入名称搜索" class="keyword" size="small" clearable @change="getDicTree" @clear="getDicTree">
          <template #prefix>
            <i class="el-icon-search el-input__icon" @click="getDicTree" />
          </template>
        </el-input>
      </div>
      <el-tree ref="dicTree" class="dicTree" :data="dicTreeList" highlight-current node-key="dicCode"
        :props="defaultProps" show-checkbox @current-change="currentDicChange" @check-change="checkChange">
        <template #default="{ data }">
          <span style="display: flex; align-items: center;" :title="data.dicCode+'-'+data.dicName">
            <i class="el-icon-notebook-2" style="font-size: 17px;margin-right:2px;color: #0078f7;"></i>
            {{ data.dicCode }} - {{ data.dicName }}
          </span>
        </template>
      </el-tree>
    </div>
    <div class="footer_t">
      <div class="footer_b">
        <el-dropdown style="margin-right:10px" @command="handleCommand">
          <el-button type="primary" size="small" icon="el-icon-plus">
            添加
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">
              添加同级字典项
            </el-dropdown-item>
            <template v-if="currentID.remark === '1'">
              <el-dropdown-item command="b">
                添加子级字典项
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown style="margin-right:10px" @command="handleCommand">
          <el-button type="primary" size="small" class="el-icon-folder-add">
            批量添加
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="c">
              批量添加同级字典项
            </el-dropdown-item>
            <template v-if="currentID.remark === '1'">
              <el-dropdown-item command="d">
                批量添加子级字典项
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" plain size="small" class="el-icon-edit" :disabled="!isRightEdit" @click="editField">
          修改
        </el-button>
        <el-button type="primary" plain size="small" class="el-icon-download" @click="exportDic">
          导出
        </el-button>
        <el-button type="primary" plain size="small" class="el-icon-upload2" @click="importDic">
          导入
        </el-button>
      </div>
      <div class="table_only">
        <div v-if="currentID.remark === '1'" class="tree-t">
          <el-tree ref="tree" class="tree_1" :data="listTree" :props="defaultProps1" :accordion="true"
            :default-expanded-keys="nodeKey" node-key="id" highlight-current @current-change="currentPid">
            <template #default="{ data }">
              <span style="display: flex; align-items: center">
                <img :src="icon" style="margin-right: 6px" alt="" />
                {{ data.cnName }}
              </span>
            </template>
          </el-tree>
        </div>
        <div :class="currentID.remark === '1'?'tree_table':'tree_tableH'">
          <el-table :data="dicTable" height="100%" highlight-current-row :row-style="rowStyle"
            :header-cell-style="headerStyle" @current-change="getTableStatus">
            <template slot="empty">
              <img :src="zanwu" alt="" />
              <p style="font-size: 16px; color: #000; margin-top: 36px">
                暂无数据
              </p>
            </template>
            <el-table-column label="分组编码" prop="dicCode" align="center" />
            <el-table-column label="值" prop="dicId" align="center" />
            <el-table-column label="名称" prop="cnName" align="center" />
            <el-table-column label="排序号" prop="sortNum" align="center" />
            <el-table-column label="备注" prop="remark" align="center" />
            <el-table-column label="标签" prop="tag" align="center" />
          </el-table>
        </div>
      </div>
    </div>
    <!-- 添加分组 -->
    <el-dialog v-dialogDrag :title="dicTypeDialogTitle" width="500px" :visible="addOrEditVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="closeDia1">
      <el-form ref="addForm" :rules="rules" label-width="85px" :model="addForm" size="small">
        <el-form-item label="分组名称" prop="dicName">
          <el-input ref="dicName" v-model="addForm.dicName" maxlength="20" show-word-limit size="small" placeholder="请输入分组名称" />
        </el-form-item>
        <el-form-item label="分组编码" prop="dicCode">
          <el-input v-model="addForm.dicCode" maxlength="20" show-word-limit size="small" placeholder="分组编码最好由数字/字母/下划线/减号组成" />
        </el-form-item>
        <el-form-item v-if="dicTypeDialogTitle==='添加字典'" label="使用树结构" prop="remark">
          <el-checkbox v-model="addForm.remark" :true-label="1" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDia1">取 消</el-button>
        <el-button type="primary" size="small" @click="getAddDicTree">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加目录 -->
    <el-dialog v-dialogDrag :title="dicDialogTitle" width="500px" :visible="addOrEditTableVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="closeDia2">
      <el-form ref="addTableForm" :rules="rules1" label-width="80px" :model="addTableForm" size="small">
        <el-form-item label="分组编码">
          <el-input v-model="currentID.dicCode" disabled size="small" />
        </el-form-item>
        <el-form-item label="分组名称">
          <el-input v-model="currentID.dicName" disabled size="small" />
        </el-form-item>
        <el-form-item label="值" prop="dicId">
          <el-input ref="dicId" v-model="addTableForm.dicId" maxlength="50" show-word-limit size="small" class="pr20" />
        </el-form-item>
        <el-form-item label="名称" prop="cnName">
          <el-input v-model="addTableForm.cnName" maxlength="20" show-word-limit size="small" />
        </el-form-item>
        <el-form-item label="排序号" prop="sortNum">
          <el-input-number v-model="addTableForm.sortNum" :min="0" :step="1" step-strictly style="width:100%" size="small" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="addTableForm.remark" maxlength="200" show-word-limit size="small" class="pr200" />
        </el-form-item>
        <el-form-item label="标签" prop="tag">
          <el-input v-model="addTableForm.tag" maxlength="20" show-word-limit size="small" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDia2">取 消</el-button>
        <el-button type="primary" size="small" @click="getAddDicTable">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量添加 -->
    <el-dialog v-dialogDrag title="批量添加" width="1050px" :visible="batchAddTableVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="closeDia3">
      <el-form label-width="68px" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="分组编码">
              <el-input v-model="currentID.dicCode" disabled size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分组名称">
              <el-input v-model="currentID.dicName" disabled size="small" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form ref="batchAddTableForm" :model="batchAddTableForm" inline size="small">
        <div v-for="(item, index) in batchAddTableForm.formList" :key="index" style="margin-top:10px;" class="batchAddTable">
          <el-form-item :ref="'formList.' + index + '.dicId'" :prop="'formList.' + index + '.dicId'" label="值" :rules="item.rules.dicId">
            <el-input v-model.trim="item.dicId" maxlength="20" show-word-limit size="small" class="pr20" />
          </el-form-item>
          <el-form-item :ref="'formList.' + index + '.cnName'" :prop="'formList.' + index + '.cnName'" label="名称" :rules="item.rules.cnName">
            <el-input v-model="item.cnName" maxlength="20" show-word-limit size="small" class="pr20" />
          </el-form-item>
          <el-form-item :ref="'formList.' + index + '.sortNum'" :prop="'formList.' + index + '.sortNum'" label="排序号" :rules="item.rules.sortNum">
            <el-input-number v-model="item.sortNum" :min="0" :step="1" step-strictly size="small" />
          </el-form-item>
          <el-form-item :ref="'formList.' + index + '.remark'" :prop="'formList.' + index + '.remark'" label="备注">
            <el-input v-model="item.remark" maxlength="200" show-word-limit size="small" class="pr200" />
          </el-form-item>
          <el-form-item :ref="'formList.' + index + '.tag'" :prop="'formList.' + index + '.tag'" label="标签">
            <el-input v-model="item.tag" maxlength="20" show-word-limit size="small" class="pr20" />
          </el-form-item>
          <el-form-item label="">
            <el-button v-if="index===0" class="iconBtn" type="primary" icon="el-icon-plus" circle size="small" @click="addComponent"></el-button>
            <el-button v-else class="iconBtn" type="danger" icon="el-icon-delete" circle size="small" @click="delComponent(index)"></el-button>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="batchAddTableVisible=false">取 消</el-button>
        <el-button type="primary" size="small" @click="getBatchAddDicTable">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入导出 -->
    <el-dialog v-dialogDrag :title="importOrexportTitle" width="500px" :visible="importOrexportVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="closeDia4" class="importOrexport">
      <el-form v-if="importOrexportTitle==='字典导入'" label-position="top" size="small">
        <el-form-item label="冲突处理:">
          <el-radio-group v-model="conflictRule">
            <el-radio :label="0">只新增、更新、不删除</el-radio>
            <el-radio :label="1">全部覆盖（删除已存在的数据）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="当字典值与名称不一致时:">
          <el-radio-group v-model="importRule">
            <el-radio :label="0">只更新名称</el-radio>
            <el-radio :label="1">只更新值</el-radio>
            <el-radio :label="2">报错，拒绝导入</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-upload ref="upload" :http-request="httpRequest" class="upload-file" accept=".export" :show-file-list="false" style="display: inline-block;"
            action="/">
            <el-button type="primary" plain size="small">
              选择文件
            </el-button>
          </el-upload>
        </el-form-item>
        <el-table v-if="importTable.length!==0" :data="importTable" :show-header="false">
          <el-table-column label="文件名称" prop="name" />
        </el-table>
      </el-form>
      <el-table v-else :data="checkDataList" height="400px" highlight-current-row border>
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">
            暂无数据
          </p>
        </template>
        <el-table-column label="分组编码" prop="dicCode" align="center" />
        <el-table-column label="分组名称" prop="dicName" align="center" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="importOrexportVisible=false">取 消</el-button>
        <el-button type="primary" size="small" @click="importOrexportDicTable">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入成功失败列表 -->
    <el-dialog v-dialogDrag title="导入成功失败列表" width="500px" :visible="importSuccessOrfailVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="closeDia5">
      <div v-if="successGroupingList.length!==0">
        <p style="font-size:17px;padding:3px">
          导入成功:
        </p>
        <el-table :data="successGroupingList" height="150px" highlight-current-row :row-style="rowStyle" :header-cell-style="headerStyle">
          <el-table-column label="分组编码" prop="dicCode" align="center" />
          <el-table-column label="分组名称" prop="dicName" align="center" />
        </el-table>
      </div>
      <div v-if="failGroupingList.length!==0">
        <p style="font-size:17px;padding:3px">
          导入失败:
        </p>
        <el-table :data="failGroupingList" height="150px" highlight-current-row :row-style="rowStyle" :header-cell-style="headerStyle">
          <el-table-column label="分组编码" prop="dicCode" align="center" />
          <el-table-column label="分组名称" prop="dicName" align="center" />
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="importSuccessOrfailVisible=false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import systemDictService from "@/CommonDP/service/admin/maintenance-service";
import { STATIC } from "@/CommonDP/utils";
import { mapState } from "vuex";

const batchAddTableFormDefault = () => ({
  formList: [
    {
      dicId: "",
      cnName: "",
      remark: '',
      tag: '',
      sortNum: 1,
      enName: '',
      pid: '0',
      rules: {
        dicId: [{ required: true, message: "请输入值", trigger: "blur" }],
        cnName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        sortNum: [{ required: true, message: "请输入排序号", trigger: "blur" }]
      }
    }
  ]
});

export default {
  name: "AdminMaintenance",
  data() {
    return {
      zanwu: STATIC + "/images/暂无数据.png",
      icon: STATIC + "/images/folder_icon.png",
      rules: {
        dicName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        dicCode: [{ required: true, message: "请输入编码", trigger: "blur" }]
      },
      rules1: {
        dicId: [{ required: true, message: "请输入值", trigger: "blur" }],
        cnName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        sortNum: [{ required: true, message: "请输入排序号", trigger: "blur" }]
      },
      dicTreeList: [],
      defaultProps: {
        label: "dicName"
      },
      dicTable: [],
      addOrEditVisible: false,
      addOrEditTableVisible: false,
      currentID: {}, // 目录选中
      addForm: {
        dicName: "",
        dicCode: "",
        remark: ""
      },
      addTableForm: {
        dicId: '',
        cnName: "",
        remark: "",
        tag: "",
        sortNum: 1,
        enName: ''
      },
      batchAddTableForm: batchAddTableFormDefault(),
      noTreeTable: undefined,
      keyWord: "",
      dicTypeDialogTitle: '添加字典',
      dicDialogTitle: '添加',
      batchAddTableVisible: false,
      checkDataList: [],
      importOrexportTitle: '字典导入',
      importOrexportVisible: false,
      conflictRule: 0,
      importRule: 0,
      importTable: [],
      importSuccessOrfailVisible: false,
      listTree: [],
      defaultProps1: {
        children: "children",
        label: "cnName"
      },
      nodeKey: [],
      cuPid: '',
      isvisAVis: true,
      successGroupingList: [],
      failGroupingList: []
    };
  },
  computed: {
    isDisabled() {
      return this.currentID.dicCode !== undefined;
    },
    isRightEdit() {
      return this.noTreeTable !== undefined || this.cuPid !== undefined;
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    checked: {
      get() {
        return this.dicTreeList.length > 0 && (this.dicTreeList.length === this.checkDataList.length);
      },
      set(val) {}
    },
    checkTitle() {
      return this.checked ? '反选' : '全选';
    }
  },
  created() {
    this.getDicTree();
  },
  methods: {
    // 目录树
    getDicTree() {
      return systemDictService.getDicList(this.keyWord).then(({ data }) => {
        this.dicTreeList = data;
        if (this.currentID.dicCode !== undefined) {
          this.$nextTick(() => {
            this.$refs.dicTree.setCurrentKey(this.currentID.dicCode);
            this.getDicTable();
          });
        }
        this.dicTable = [];
        this.noTreeTable = undefined;
        this.cuPid = undefined;
        this.listTree = [];
      });
    },
    // 新增分组
    addDicTree() {
      this.dicTypeDialogTitle = '添加字典';
      this.addOrEditVisible = true;
      this.$nextTick(() => {
        this.$refs.dicName.focus();
        this.$refs.addForm.clearValidate();
      });
    },
    // 编辑分组
    async editDicTree() {
      const y = this.currentID;
      if (y !== undefined) {
        this.dicTypeDialogTitle = '修改字典';
        this.addOrEditVisible = true;
        const params = {
          dicCode: y.dicCode
        };
        const res = await systemDictService.getDicInfo(params);
        this.addForm = res.data;
      } else {
        this.$message({
          showClose: true,
          type: "warning",
          message: "请先选择目录"
        });
      }
    },
    // 新增分组确定
    getAddDicTree() {
      const y = this.currentID;
      const { dicName, dicCode, remark } = this.addForm;
      this.$refs.addForm.validate().then(async () => {
        if (this.dicTypeDialogTitle === '添加字典') {
          const params = {
            dicName,
            dicCode,
            remark
          };
          const form = this.commonFormData(params);
          await systemDictService.saveDicList(form);
          this.$message({
            showClose: true,
            type: "success",
            message: "添加成功"
          });
        } else {
          const params = {
            dicName,
            newDicCode: dicCode,
            dicCode: y.dicCode
          };
          const form = this.commonFormData(params);
          await systemDictService.updateDicList(form);
          this.$message({
            showClose: true,
            type: "success",
            message: "修改成功"
          });
        }
        this.getDicTree();
        this.$refs.addForm.resetFields();
        this.addOrEditVisible = false;
      });
    },
    commonFormData(params) {
      const form = new FormData();
      for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
          const element = params[key];
          form.append(key, element);
        }
      }
      return form;
    },
    // 右边树结构
    async getDicTable(val) {
      const f = this.currentID;
      if (f.remark === "1") {
        const param = {
          dicCode: f.dicCode
        };
        const { data } = await systemDictService.getDicContentList(param);
        this.listTree = data;
        if (this.cuPid !== undefined) {
          await this.$nextTick(() => {});
          this.nodeKey = [val || this.cuPid.id];
          this.$refs.tree.setCurrentKey(val || this.cuPid.id);
        }
      } else {
        const param = {
          dicCode: f.dicCode
        };
        const res = await systemDictService.getDicContentList(param);
        this.dicTable = res.data;
      }
    },

    // 选中左侧目录树
    currentDicChange(val) {
      this.currentID = val;
      this.dicTable = [];
      this.noTreeTable = undefined;
      this.cuPid = undefined;
      this.getDicTable();
    },

    // 添加
    addFieldSame(val) {
      this.isvisAVis = !val;
      this.addOrEditTableVisible = true;
      this.dicDialogTitle = '添加';
      this.$nextTick(() => {
        this.$refs.dicId.focus();
        this.$refs.addTableForm.clearValidate();
      });
      this.addTableForm.dicCode = this.currentID.dicCode;
    },
    // 修改
    async editField() {
      const f = this.cuPid;
      const e = this.currentID;
      const d = this.noTreeTable;
      let id = '';
      let dicCode = '';
      if (e.remark === "1") {
        id = f.id;
        dicCode = f.dicCode;
      } else {
        id = d.id;
        dicCode = d.dicCode;
      }
      this.addOrEditTableVisible = true;
      this.dicDialogTitle = '修改';
      const params = {
        id,
        dicCode
      };
      const res = await systemDictService.getDicContentByID(params);
      this.addTableForm = res.data;
    },
    // 添加/修改确定
    async getAddDicTable() {
      await this.$refs.addTableForm.validate();
      const d = this.currentID;
      const f = this.cuPid;
      let pid = '0';
      const { dicId, cnName, enName, remark, tag, sortNum } = this.addTableForm;
      if (this.dicDialogTitle === '添加') {
        if (f !== undefined) {
          pid = this.isvisAVis ? f.pid : f.id;
        }
        const params = {
          dicCode: d.dicCode,
          dicName: d.dicName,
          dicId,
          cnName,
          enName,
          remark,
          tag,
          sortNum,
          pid,
          enterpriseId: this.enterpriseId
        };
        const form = this.commonFormData(params);
        await systemDictService.addDicContent(form);
        this.$message({
          showClose: true,
          type: "success",
          message: "添加成功"
        });
      } else {
        const params = {
          dicCode: d.dicCode,
          dicName: d.dicName,
          dicId: f !== undefined ? f.dicId : this.noTreeTable.dicId,
          cnName,
          enName,
          remark,
          tag,
          sortNum,
          pid: this.addTableForm.pid,
          enterpriseId: this.enterpriseId,
          newDicId: dicId
        };
        const form = this.commonFormData(params);
        await systemDictService.updateDicContent(form);
        this.$message({
          showClose: true,
          type: "success",
          message: "修改成功"
        });
      }
      this.getDicTable(dicId);
      if (f !== undefined) {
        this.getDicTable11(dicId);
      }
      this.addOrEditTableVisible = false;
      this.$refs.addTableForm.resetFields();
    },
    // 选中表格
    getTableStatus(val) {
      this.noTreeTable = val;
    },
    closeDia1() {
      this.addOrEditVisible = false;
      this.$refs.addForm.resetFields();
    },
    closeDia2() {
      this.addOrEditTableVisible = false;
      this.$refs.addTableForm.resetFields();
    },
    batchAdd(val) {
      this.isvisAVis = !val;
      this.batchAddTableVisible = true;
      this.batchAddTableForm = batchAddTableFormDefault();
      const f = this.cuPid;
      let pid = '0';
      if (f !== undefined) {
        pid = this.isvisAVis ? f.pid : f.id;
      }
      this.batchAddTableForm.formList[0].pid = pid;
      this.$nextTick(() => {
        this.$refs.batchAddTableForm.clearValidate();
      });
    },
    closeDia3() {
      this.batchAddTableVisible = false;
    },
    async getBatchAddDicTable() {
      await this.$refs.batchAddTableForm.validate(async valid => {
        if (valid) {
          const { dicCode } = this.currentID;
          const list = this.batchAddTableForm.formList;
          await systemDictService.batchAddDicItem(dicCode, list);
          this.$message({
            showClose: true,
            type: "success",
            message: "批量添加成功"
          });
          this.getDicTable();
          this.batchAddTableVisible = false;
        } else {
          return false;
        }
      });
    },
    addComponent() {
      const f = this.cuPid;
      let pid = '0';
      if (f !== undefined) {
        pid = this.isvisAVis ? f.pid : f.id;
      }
      const obj = {
        dicId: "",
        cnName: "",
        remark: '',
        tag: '',
        sortNum: 1,
        enName: '',
        pid,
        rules: {
          dicId: [{ required: true, message: "请输入值", trigger: "blur" }],
          cnName: [{ required: true, message: "请输入名称", trigger: "blur" }],
          sortNum: [{ required: true, message: "请输入排序号", trigger: "blur" }]
        }
      };
      this.batchAddTableForm.formList.push(obj);
    },
    delComponent(index) {
      this.batchAddTableForm.formList.splice(index, 1);
    },
    allCheck() {
      if (!this.checked) {
        const ids = this.dicTreeList.map(i => i.dicCode);
        this.$refs.dicTree.setCheckedKeys(ids);
      } else {
        this.$refs.dicTree.setCheckedKeys([]);
      }
    },
    checkChange(data, checked) {
      if (checked) {
        this.checkDataList.push(data);
      } else {
        const index = this.checkDataList.findIndex(({ dicCode }) => dicCode === data.dicCode);
        this.checkDataList.splice(index, 1);
      }
    },
    closeDia4() {
      this.importOrexportVisible = false;
    },
    async importOrexportDicTable() {
      if (this.importOrexportTitle === '字典导入') {
        if (!this.importTable.length) {
          this.$message({
            showClose: true,
            message: "请选择文件",
            type: "warning"
          });
          return;
        }
        await this.$confirm("是否确定导入吗？");
        this.successGroupingList = [];
        this.failGroupingList = [];
        const data = new FormData();
        data.append("file", this.importTable[0]);
        data.append("conflictRule", this.conflictRule);
        data.append("importRule", this.importRule);
        const res = await systemDictService.dicContentImport(data);
        this.importOrexportVisible = false;
        this.$message({
          showClose: true,
          type: "success",
          message: "导入成功"
        });
        // this.successGroupingList = res.data;
        this.failGroupingList = res.data;
        this.getDicTable();
        const f = this.cuPid;
        if (f !== undefined) {
          this.getDicTable11();
        }
        if (this.failGroupingList.length || this.successGroupingList.length) { this.importSuccessOrfailVisible = true; }
      } else {
        const dicCodeList = this.checkDataList.map(i => i.dicCode);
        const res = await systemDictService.dicContentExport(dicCodeList);
        const today = new Date();
        const currentDate = today.getFullYear() + '' + (today.getMonth() + 1) + '' + today.getDate();
        const fileName = '字典导出-' + currentDate + ".export";
        if ("msSaveOrOpenBlob" in navigator) {
          // 兼容ie
          window.navigator.msSaveOrOpenBlob(res, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = res;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        this.importOrexportVisible = false;
      }
    },
    exportDic() {
      if (this.checkDataList.length === 0) {
        this.$message({
          showClose: true,
          type: "warning",
          message: "请先选择左侧分组"
        });
        return;
      }
      this.importOrexportTitle = '字典导出';
      this.importOrexportVisible = true;
    },
    importDic() {
      this.importTable = [];
      this.importOrexportTitle = '字典导入';
      this.conflictRule = 0;
      this.importRule = 0;
      this.importOrexportVisible = true;
    },
    async httpRequest({ file }) {
      this.importTable = [];
      this.importTable.push(file);
    },
    closeDia5() {
      this.importSuccessOrfailVisible = false;
    },
    // 右边树结构选中节点
    currentPid(val) {
      this.cuPid = val;
      this.getDicTable11();
    },
    async getDicTable11(val) {
      const f = this.cuPid;
      const param = {
        id: val || f.id,
        dicCode: f.dicCode
      };
      const { data } = await systemDictService.getDicContentByID(param);
      const arr = [];
      arr.push(data);
      this.dicTable = arr;
    },
    // 添加子级
    addField(val) {
      const y = this.cuPid;
      if (y !== undefined) {
        if (val === 1) {
          this.addFieldSame(val);
        } else {
          this.batchAdd(val);
        }
      } else {
        this.$message({
          type: "warning",
          message: "请先选择字典项"
        });
      }
    },
    handleCommand(val) {
      if (val === 'a') {
        if (!this.isDisabled) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "请先选择左侧分组"
          });
          return;
        }
        this.addFieldSame();
      } else if (val === 'b') {
        this.addField(1);
      } else if (val === 'c') {
        if (!this.isDisabled) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "请先选择左侧分组"
          });
          return;
        }
        this.batchAdd();
      } else if (val === 'd') {
        this.addField(2);
      }
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:34px;border-top:1px solid #EFF0F9";
    }
  }
};
</script>

<style lang="scss" scoped>
$left_width: 285px;
$top_height: 56px;
$minddle_height: 40px;
.mainAll {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .header_h {
    font-size: 16px;
    height: $top_height;
    line-height: $top_height;
    font-weight: 600;
    padding-left: var(--big-space);
    letter-spacing: 1px;
    border-bottom: 1px solid #ebefff;
  }
}
.left {
  overflow: auto;
  position: absolute;
  top: $top_height;
  bottom: 0;
  left: 0;
  width: $left_width;
  border-right: 1px solid #ebefff;
  display: flex;
  flex-direction: column;
  .button-1 {
    padding: var(--middle-space) var(--big-space);
    border-bottom: 1px dashed #ebefff;
    display: flex;
    flex-direction: row;
    align-items: center;
    /deep/ .el-checkbox{
      margin-left: 3px;
      margin-right:20px
    }
  }
  .tree_font {
    font-size: 14px;
    font-weight: bold;
    padding: var(--middle-space) var(--big-space);
  }
  .dicTree {
    overflow: auto;
    height: 1px;
    flex: 1 0 1px;
    font-size: 14px;
    background-color: 0;
  }
}
.footer_t{
  position: absolute;
  top: $top_height;
  left: $left_width;
  right: 0;
  bottom: 0;
  padding: 0 var(--big-space) var(--middle-space);
}
.footer_b {
  padding: var(--middle-space) 0;
  border-bottom: 1px dashed #ebefff;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table_only {
  position: absolute;
  top: calc(32px + var(--middle-space) * 2);
  left: var(--big-space);
  right: var(--big-space);
  bottom: var(--middle-space);
}

.tree-t {
  overflow: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 20px;
  bottom: 200px;
}

.tree_table {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 200px;
}
.iconBtn{
  padding: 5px 10px !important
}
.tree_tableH{
  height: 100%;
}
/deep/.el-divider--horizontal {
  margin: 0;
}
/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
.batchAddTable{
  /deep/ .el-input__inner{
    width: 130px;
  }
}
.pr200 /deep/.el-input__inner{
  padding-right: 57px;
}
.pr20 /deep/.el-input__inner{
  padding-right: 48px;
}
.importOrexport{
  /deep/ .el-radio{
    display: block;
    margin-bottom: 10px;
  }
}
</style>
